import { createContext } from 'react';

export interface MessageContextType {
  showSuccess: (content: string) => void;
  showError: (content: string) => void;
  showWarning: (content: string) => void;
  showInfo: (content: string) => void;
  showLoading: (content: string) => () => void;
}

export const MessageContext = createContext<MessageContextType | undefined>(undefined);
